function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 1,
  fill: "#F0F0F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 11.12L4.8 8.64L3 6.16H4.37L5.63 7.92L6.88 6.16H8.26L6.45 8.64L8.26 11.12H6.88L5.63 9.36L4.37 11.12H3Z",
  fill: "#1A172A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3955 11.24C10.9355 11.24 10.5188 11.16 10.1455 11C9.77214 10.8333 9.47214 10.58 9.24547 10.24C9.0188 9.9 8.8988 9.47333 8.88547 8.96H10.1455C10.1521 9.3 10.2621 9.58667 10.4755 9.82C10.6955 10.0467 11.0021 10.16 11.3955 10.16C11.7688 10.16 12.0555 10.0567 12.2555 9.85C12.4555 9.64333 12.5555 9.38333 12.5555 9.07C12.5555 8.70333 12.4221 8.42667 12.1555 8.24C11.8955 8.04667 11.5588 7.95 11.1455 7.95H10.6255V6.9H11.1555C11.4955 6.9 11.7788 6.82 12.0055 6.66C12.2321 6.5 12.3455 6.26333 12.3455 5.95C12.3455 5.69 12.2588 5.48333 12.0855 5.33C11.9188 5.17 11.6855 5.09 11.3855 5.09C11.0588 5.09 10.8021 5.18667 10.6155 5.38C10.4355 5.57333 10.3355 5.81 10.3155 6.09H9.06547C9.09214 5.44333 9.31547 4.93333 9.73547 4.56C10.1621 4.18667 10.7121 4 11.3855 4C11.8655 4 12.2688 4.08667 12.5955 4.26C12.9288 4.42667 13.1788 4.65 13.3455 4.93C13.5188 5.21 13.6055 5.52 13.6055 5.86C13.6055 6.25333 13.4955 6.58667 13.2755 6.86C13.0621 7.12667 12.7955 7.30667 12.4755 7.4C12.8688 7.48 13.1888 7.67333 13.4355 7.98C13.6821 8.28 13.8055 8.66 13.8055 9.12C13.8055 9.50667 13.7121 9.86 13.5255 10.18C13.3388 10.5 13.0655 10.7567 12.7055 10.95C12.3521 11.1433 11.9155 11.24 11.3955 11.24Z",
  fill: "#1A172A"
});

function SvgX3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX3);
export default __webpack_public_path__ + "static/media/x3.5991f843.svg";
export { ForwardRef as ReactComponent };